import { css } from 'styled-components';
export const DisabledSchemeKey = 'shade5';
export const DisabledBorders = (borderThickness = '2px') => css `
	border: ${borderThickness} solid ${(props) => props.theme.schemes[DisabledSchemeKey].passive};

	:hover {
		border: ${borderThickness} solid ${(props) => props.theme.schemes[DisabledSchemeKey].hover};
	}
`;
//# sourceMappingURL=InputUtils.js.map